<template>
  <b-modal
    :ok-disabled="disabled"
    :cancel-disabled="disabled"
    @ok.prevent="submit"
    class="in-form-modal"
    ok-title="ثبت"
    cancel-title="لغو"
    id="product-change-quantity-modal"
    :title="type == 'increment' ? 'اضافه کردن به انبار' : 'کم کردن از انبار'"
  >
    <label for="quantity"> تعداد <i class="text-danger">*</i></label>
    <b-form-input id="quantity" type="number" v-model="quantity" />
    <label for="des"> توضیحات <i class="text-danger">*</i></label>
    <b-form-textarea
      id="desc"
      name="description"
      v-model="description"
    ></b-form-textarea>
  </b-modal>
</template>

<script>
import { BFormInput, BModal, BFormTextarea } from "bootstrap-vue";

export default {
  name: "ProductChangeQuantity",
  components: { BFormInput, BModal, BFormTextarea },
  data() {
    return {
      disabled: false,
      quantity: 1,
      description: "",
    };
  },
  props: {
    type: String,
    variety: Object,
  },
  methods: {
    async submit() {
      try {
        this.disabled = true;
        const response = await this.$axios.post("admin/stores", {
          variety_id: this.variety.id,
          type: this.type,
          quantity: this.quantity,
          description: this.description,
        });
        this.variety.quantity = response.data.data.store.balance;
        this.$root.$emit("bv::hide::modal", "product-change-quantity-modal");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>

<style scoped></style>
